import { useState, useCallback, useRef } from 'react';
import {
  useMeetingSelector,
  useStableEvent
} from '../meeting/meetingProviderContextDef';
import { events, rejectNotJoined } from '../utils';
/**
 *
 * @returns {{
 *  startWhiteboard: () => Promise<void>,
 *  stopWhiteboard: () => Promise<void>,
 *  whiteboardUrl: string | null
 * }}
 */
const useWhiteboard = () => {
  const selectMeeting = useCallback(s => s.meeting, []);
  const meeting = useMeetingSelector(selectMeeting);
  const selectIsMeetingJoined = useCallback(s => s.isMeetingJoined, []);
  const isMeetingJoined = useMeetingSelector(selectIsMeetingJoined);

  const [whiteboardUrl, setWhiteboardUrl] = useState(null);

  const meetingRef = useRef(meeting);
  meetingRef.current = meeting;
  const isMeetingJoinedRef = useRef(isMeetingJoined);
  isMeetingJoinedRef.current = isMeetingJoined;

  useStableEvent(events['whiteboard-started'], data => {
    if (data?.url) setWhiteboardUrl(data.url);
  });
  useStableEvent(events['whiteboard-stopped'], () => setWhiteboardUrl(null));

  const startWhiteboard = useCallback(() => {
    if (!isMeetingJoinedRef.current || !meetingRef.current) {
      return rejectNotJoined('startWhiteboard');
    }

    return meetingRef.current.startWhiteboard();
  }, []);

  const stopWhiteboard = useCallback(() => {
    if (!isMeetingJoinedRef.current || !meetingRef.current) {
      return rejectNotJoined('stopWhiteboard');
    }

    return meetingRef.current.stopWhiteboard();
  }, []);

  return { whiteboardUrl, startWhiteboard, stopWhiteboard };
};

export default useWhiteboard;
